export default "__VITE_ASSET__152cf3d1__"